import { render, staticRenderFns } from "./AddBudgetExpense.vue?vue&type=template&id=bbd53508"
import script from "./AddBudgetExpense.vue?vue&type=script&lang=js"
export * from "./AddBudgetExpense.vue?vue&type=script&lang=js"
import style0 from "./AddBudgetExpense.vue?vue&type=style&index=0&id=bbd53508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports